<template>
    <v-dialog
        v-model="show"
        persistent
        eager
        :width="displayWidth"
        @keydown.esc="onEscapeKeydown"
    >
        <v-card
            class="scrollable-container pb-2"
            height="450px"
            role="region"
            aria-label="jobs-dialog"
        >
            <v-card-title>
                {{ title }}
            </v-card-title>
            <v-card-text class="scrollable-content pb-0 px-3">
                <pre>{{ item | pretty }}</pre>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn outlined small cy-data="close" @click="onCloseClick"
                    >Close</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'EventDialog',
    filters: {
        pretty(value) {
            return JSON.stringify(value, null, 2);
        }
    },
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: 'Venue Event Details'
        },
        width: {
            type: String,
            required: false,
            default: '550'
        },
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isDataLoading: false
        };
    },
    computed: {
        displayWidth() {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return this.width;
            }
            return '90%';
        }
    },
    methods: {
        onCloseClick() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss" scoped></style>
